import * as React from "react"

import { cn } from "@/lib/utils"

const Input = React.forwardRef(({ className, type, ...props }, ref) => {
  return (
    <input
      type={type}
      className={cn(
        "flex h-10 w-full rounded-lg border border-slate-200 bg-white px-3 py-2 text-sm text-slate-900",
        "shadow-sm transition-all duration-150",
        "placeholder:text-slate-400",
        "hover:border-slate-300",
        "focus:outline-none focus:ring-2 focus:ring-[#108981]/20 focus:border-[#108981]",
        "disabled:cursor-not-allowed disabled:bg-slate-50 disabled:text-slate-500",
        "file:border-0 file:bg-transparent file:text-sm file:font-medium file:text-slate-700",
        className
      )}
      ref={ref}
      {...props} />
  );
})
Input.displayName = "Input"

// Variant for financial/number inputs
const InputAmount = React.forwardRef(({ className, currency = "₦", ...props }, ref) => {
  return (
    <div className="relative">
      <span className="absolute left-3 top-1/2 -translate-y-1/2 text-slate-500 font-medium text-sm">
        {currency}
      </span>
      <input
        type="number"
        className={cn(
          "flex h-10 w-full rounded-lg border border-slate-200 bg-white pl-8 pr-3 py-2",
          "text-sm text-slate-900 font-mono tabular-nums text-right",
          "shadow-sm transition-all duration-150",
          "placeholder:text-slate-400",
          "hover:border-slate-300",
          "focus:outline-none focus:ring-2 focus:ring-[#108981]/20 focus:border-[#108981]",
          "disabled:cursor-not-allowed disabled:bg-slate-50 disabled:text-slate-500",
          className
        )}
        ref={ref}
        {...props} />
    </div>
  );
})
InputAmount.displayName = "InputAmount"

export { Input, InputAmount }
